<script>
  /* ランキングの行をタップしたときに開く、その人のプロフィール。
     row（公開ドキュメント）の中身だけで描画できる。追加の取得はしない。 */
  import { ERA_BY_ID } from "../../data/eras.js";
  import { eraForEvo } from "../../data/journeyEngine.js";
  import { fmtEra, fmtFuture, fmtEvo, fmtSince, toEpochMs } from "../lib/format.js";
  import { organismInner, defaultOrganism, FORM_NAMES } from "../../data/organism.js";

  /** @type {{ profile: any, rank?: number|null, isMe?: boolean, onClose: () => void }} */
  let { profile, rank = null, isMe = false, onClose } = $props();

  const at = $derived(eraForEvo(profile?.evo || 0));
  const era = $derived(ERA_BY_ID[profile?.eraId] || at.era);
  const form = $derived(profile?.form || at.era.form);
  const whenText = $derived(at.isFuture ? fmtFuture(at.futureMa) : fmtEra(at.ma));
  const lastSeen = $derived.by(() => {
    const t = toEpochMs(profile?.lastLoginAt) || toEpochMs(profile?.updatedAt);
    return t ? fmtSince(t) : "";
  });

  function onKey(e) {
    if (e.key === "Escape") onClose();
  }
</script>

<svelte:window onkeydown={onKey} />

{#if profile}
  <div
    class="pf-backdrop"
    onclick={onClose}
    onkeydown={(e) => e.key === "Enter" && onClose()}
    role="button"
    tabindex="-1"
    aria-label="閉じる"
  ></div>
  <div class="pf-modal" role="dialog" aria-modal="true" aria-label="プロフィール">
    <button class="pf-close" onclick={onClose} aria-label="閉じる">✕</button>

    <div class="pf-head">
      <span class="pf-av">
        <svg viewBox="0 0 100 100" aria-hidden="true">
          {@html organismInner(form, profile.organism || defaultOrganism())}
        </svg>
      </span>
      <div class="pf-id">
        <div class="pf-name">
          {profile.nickname || "ななしの生物"}
          {#if isMe}<span class="pf-me-tag">あなた</span>{/if}
        </div>
        <div class="pf-era">{era.em} {era.name} · {whenText}</div>
        <div class="tiny pf-form">{FORM_NAMES[form] || ""}</div>
      </div>
    </div>

    {#if profile.bio}
      <p class="pf-bio">{profile.bio}</p>
    {:else}
      <p class="pf-bio empty">自己紹介はまだ書かれていません。</p>
    {/if}

    <div class="pf-stats">
      {#if rank}
        <div class="pf-stat"><b>{rank}位</b><span>ランキング</span></div>
      {/if}
      <div class="pf-stat"><b>{fmtEvo(profile.evo || 0)}</b><span>進化ポイント</span></div>
      <div class="pf-stat"><b>{profile.solvedCount || 0}</b><span>解いた問題</span></div>
    </div>

    {#if lastSeen}
      <div class="tiny pf-seen">🕒 最終ログイン {lastSeen}</div>
    {/if}
  </div>
{/if}
